import { globalEventBus } from '@fiverr-private/futile';
import { ACTIONS } from '../helpers/actionTypes';
import { BIANKA_EVENT_NAME } from '../helpers/eventName';

/**
 * Reports an activity event.
 * @param args
 * @return {Promise}
 */
export const reportActivity = (args) => globalEventBus.deferred(
    BIANKA_EVENT_NAME,
    { ...args, biankaActionType: ACTIONS.ACTIVITY }
);

/**
 * Reports a business event.
 * @param args
 * @return {Promise}
 */
export const reportBusiness = (args) => globalEventBus.deferred(
    BIANKA_EVENT_NAME,
    { ...args, biankaActionType: ACTIONS.BUSINESS }
);
